import React from 'react';
import { FormControl, InputLabel, Select, MenuItem, CircularProgress, SelectChangeEvent } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../../../../../app/hooks';
import { updateTicketWorkflow } from '../../../../state';
import { useGetTicketStatusesQuery } from '../../../../../../services/DimensionService/dimensionApi';

interface StatusEditProps {
  show?: boolean;
}

const StatusEdit: React.FC<StatusEditProps> = ({ show = true }) => {
  const dispatch = useAppDispatch();
  const { currentTicket } = useAppSelector(state => state.ticket);
  const { data: statuses, isLoading, error } = useGetTicketStatusesQuery();

  const handleChange = (event: SelectChangeEvent) => {
    dispatch(updateTicketWorkflow({ status: event.target.value }));
  };

  // Don't render if show is false
  if (!show) {
    return null;
  }

  return (
    <FormControl size="small" fullWidth>
      <InputLabel>Status</InputLabel>
      <Select
        value={currentTicket?.workflow.status || 'Draft'}
        onChange={handleChange}
        label="Status"
        disabled={isLoading || !!error}
      >
        {isLoading ? (
          <MenuItem disabled>
            <CircularProgress size={20} sx={{ mr: 1 }} />
            Loading statuses...
          </MenuItem>
        ) : error ? (
          <MenuItem disabled>Error loading statuses</MenuItem>
        ) : (
          statuses?.map((status) => (
            <MenuItem key={status.value} value={status.value}>
              {status.name}
            </MenuItem>
          ))
        )}
      </Select>
    </FormControl>
  );
};

export default StatusEdit;
